import { getNamespace } from '../utils/namespace'

export default {
  login: {
    path: getNamespace() + '/ding/login',
    method: 'post'
  },
  getCorpId: {
    path: getNamespace() + '/auth/ding/corpId/get',
    method: 'post'
  },
  getTenantList: {
    path: getNamespace() + '/auth/ding/before/login',
    method: 'post',
    loading: { text: '自动登录中...' }
  },
  ddLogin: {
    path: getNamespace() + '/auth/ding/login',
    method: 'post',
    loading: { text: '自动登录中...' }
  },
  getAuthParams: {
    path: getNamespace() + '/api/ding/jsapi/get',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/apis/dingding.js